import request from "@/utils/request";

export function pollenBottleGet(params) {
    return request({
        url: "/api/services/app/PollenBottle/Get",
        method: "GET",
        params
    });
}

export function pollenBottleGetAll(params) {
    return request({
        url: "/api/services/app/PollenBottle/GetAll",
        method: "GET",
        params
    });
}

export function pollenBottleGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/PollenBottle/GetAllForDropdown",
        method: "GET",
        params
    });
}


export function pollenBottleCreate(data) {
    return request({
        url: "/api/services/app/PollenBottle/Create",
        method: "post",
        data
    });
}

export function pollenBottleUpdate(data) {
    return request({
        url: "/api/services/app/PollenBottle/Update",
        method: "put",
        data
    });
}

export function pollenBottleDelete(params) {
    return request({
        url: "/api/services/app/PollenBottle/Delete",
        method: "delete",
        params
    });
}

export function pollenBottleDeleteMany(data) {
    return request({
        url: "/api/services/app/PollenBottle/DeleteMany",
        method: "post",
        data
    });
}




// WEBPACK FOOTER //
// ./src/api/pollen_bottle.js